<template>
	<div class="inline-flex items-center gap-2">
		<span v-if="label && variant == 'text'" :class="labelClass">{{ label }}:</span>
		<VDropdown :distance="6" :placement="placement" v-model:shown="open">
			<AppButton v-if="variant == 'button'" :icon="icon" :disabled="disabled">
				<span :class="[valueClass, { 'opacity-60': isEmpty }]">{{ displayValue }}</span>
				<template #suffix>
					<AppIcon
						icon="fa-chevron-down"
						class="ml-2 text-xs opacity-70 transition-transform"
						:class="{ 'rotate-180': open }"
					/>
				</template>
			</AppButton>
			<button
				v-else
				type="button"
				:disabled="disabled"
				:class="[
					'inline-flex items-center gap-1.5 rounded-md text-left hover:bg-black/5 dark:hover:bg-white/10 disabled:cursor-default disabled:hover:bg-transparent',
					outlined
						? 'w-full justify-between border border-gray-300 dark:border-gray-600 px-2.5 py-1.5'
						: '-mx-1.5 px-1.5 py-0.5',
				]"
			>
				<AppIcon v-if="icon" :icon="icon" fixed-width class="text-sm opacity-60"/>
				<span :class="[valueClass, { 'opacity-60': isEmpty }]">{{ displayValue }}</span>
				<AppIcon
					v-if="!disabled"
					icon="fa-chevron-down"
					class="text-xs opacity-60 transition-transform"
					:class="{ 'rotate-180': open }"
				/>
			</button>
			<template #popper="{ hide }">
				<slot :hide="hide"/>
			</template>
		</VDropdown>
	</div>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";

const props = withDefaults(
	defineProps<{
		value?: string | null;
		label?: string;
		icon?: string;
		placeholder?: string;
		disabled?: boolean;
		placement?: string;
		variant?: "text" | "button";
		labelClass?: string;
		valueClass?: string;
		/** Render the trigger as a bordered dropdown-input box instead of inline text. Only affects the "text" variant. */
		outlined?: boolean;
	}>(),
	{
		placement: "bottom-start",
		variant: "text",
		labelClass: "font-bold",
		valueClass: "",
	},
);

const open = ref(false);
const isEmpty = computed(() => props.value == null || props.value == "");
const displayValue = computed(() => (isEmpty.value ? (props.placeholder ?? "-") : props.value));
</script>
